import React, { Fragment, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import Select from 'react-select';
import '../shared.css';

const PurchaseReturnCreate = () => {
    const history = useHistory();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [confirmRemove, setConfirmRemove] = useState(null);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [formData, setFormData] = useState({});
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [itemsOptions, setItemsOptions] = useState([]);
    const [itemdetails, setItemDetails] = useState([]);
    const [selectedItems, setSelectedItem] = useState(null);
    const [isValid, setIsValid] = useState(true);

    const [modalData, setModalData] = useState({
        ItemName: '', ItemId: '', Quantity: '1',
        Rate: '', Amount: '', GSTRate: '', GSTAmount: '', TotalAmount: '', balanceStock: 0,
    });

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const response = await fetchData('PurchaseReturnApi', `/Item/${companyId}/${branchId}`, token);
                if (response.responseCode === '1111') {
                    setItemsOptions(response.response_data.map(item => ({
                        value: item.Id, label: item.Code + '-' + item.Name
                    })));
                    setItemDetails(response.response_data);
                }
                const d = new Date();
                const today = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                setFormData(prev => ({ ...prev, GRNDate: today, LRDate: today, BranchId: branchId, CompanyId: companyId, CreatedBy: userId }));
            } catch (e) { console.error(e); }
        };
        fetchItems();
    }, [companyId, branchId, token, userId]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleItemSelect = (option) => {
        setSelectedItem(option);
        const item = itemdetails.find(i => i.Id === (option ? option.value : ''));
        if (item) {
            const qty = parseFloat(modalData.Quantity) || 0;
            const rate = parseFloat(item.PurchaseRate.toFixed(2)) || 0;
            const gst = parseFloat(item.GSTRate.toFixed(2)) || 0;
            const amount = (qty * rate).toFixed(2);
            const gstAmt = ((amount * gst) / 100).toFixed(2);
            setModalData({
                ...modalData, ItemName: option.label, ItemId: option.value,
                Rate: rate.toFixed(2), GSTRate: gst.toFixed(2),
                Amount: amount, GSTAmount: gstAmt,
                TotalAmount: (parseFloat(amount) + parseFloat(gstAmt)).toFixed(2),
                balanceStock: item.balanceStock,
            });
        } else {
            setModalData({ ...modalData, ItemName: option ? option.label : '', ItemId: option ? option.value : '', Rate: '0.00', GSTRate: '0.00', balanceStock: 0 });
        }
    };

    const handleModalInputChange = (e) => {
        const qty = parseFloat(e.target.value) || 0;
        setIsValid(qty <= modalData.balanceStock);
        const rate = parseFloat(modalData.Rate) || 0;
        const gst = parseFloat(modalData.GSTRate) || 0;
        const amount = (qty * rate).toFixed(2);
        const gstAmt = ((amount * gst) / 100).toFixed(2);
        setModalData({ ...modalData, Quantity: qty, Amount: amount, GSTAmount: gstAmt, TotalAmount: (parseFloat(amount) + parseFloat(gstAmt)).toFixed(2) });
    };

    const totalCalculation = (items) => {
        const qty = items.reduce((s, i) => s + parseFloat(i.Quantity), 0);
        const amt = items.reduce((s, i) => s + parseFloat(i.Amount), 0);
        const gst = items.reduce((s, i) => s + parseFloat(i.GSTAmount), 0);
        const total = items.reduce((s, i) => s + parseFloat(i.TotalAmount), 0);
        setFormData(prev => ({ ...prev, TotalQuantity: qty, Amount: amt.toFixed(2), GSTAmount: gst.toFixed(2), TotalAmount: total.toFixed(2), ModifiedBy: userId }));
    };

    const saveModalData = () => {
        if (!modalData.ItemId) { setErrorMessageModel('Item is required'); return; }
        if (!modalData.Quantity || isNaN(modalData.Quantity)) { setErrorMessageModel('Quantity must be a valid number'); return; }
        if (parseFloat(modalData.Quantity) > modalData.balanceStock) { setErrorMessageModel('Quantity exceeds available stock.'); return; }
        setErrorMessageModel('');
        const updated = [modalData, ...invoicedeatils];
        setInvoicedeatils(updated);
        setModalData({ ItemName: '', ItemId: '', Quantity: '1', Rate: '', Amount: '', GSTRate: '', GSTAmount: '', TotalAmount: '', balanceStock: 0 });
        setSelectedItem(null);
        totalCalculation(updated);
    };

    const removeRecord = (index) => setConfirmRemove(index);
    const confirmRemoveRecord = () => {
        const updated = [...invoicedeatils];
        updated.splice(confirmRemove, 1);
        setConfirmRemove(null);
        setInvoicedeatils(updated);
        totalCalculation(updated);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!formData.GRNNumber) { setErrorMessage('GRN/CN Number is required!'); setIsLoading(false); return; }
        if (!formData.LRNumber) { setErrorMessage('LR Number is required!'); setIsLoading(false); return; }
        if (!invoicedeatils.length) { setErrorMessage('Item Details are required!'); setIsLoading(false); return; }

        const payload = {
            Purchase: { ...formData, ModifiedBy: userId, BranchId: branchId, CompanyId: companyId },
            PurchaseDetails: invoicedeatils
        };
        postData('PurchaseReturnApi', payload, token)
            .then(() => history.push('/Home'))
            .catch(err => { console.error(err); setIsLoading(false); });
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const d = new Date(dateString);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };

    return (
        <Fragment>
            <div className="pg-container">
                {/* ── Header ── */}
                <div className="pg-header">
                    <h5 className="pg-title">Purchase Return - Create</h5>
                    <div className="pg-header-actions">
                        <div className="pg-action-row">
                            <button className="pg-btn pg-btn-success" onClick={handleSubmit} disabled={isLoading}>
                                <DoneIcon /> {isLoading ? <CircularProgress size={14} color="inherit" /> : 'Save'}
                            </button>
                            <Link to="/PurchaseReturnIndex" className="pg-btn pg-btn-danger">
                                <CloseIcon /> Cancel
                            </Link>
                        </div>
                    </div>
                </div>

                {errorMessage && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
                {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

                <div className="pg-card">
                    {/* ── Row 1: GRN/CN + LR ── */}
                    <div className="pg-hpanel">
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">GRN/CN Date <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="date"
                                value={formatDateForInput(formData.GRNDate)} onChange={handleChange} name="GRNDate" readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">GRN/CN Number <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="text" placeholder="GRN/CN Number"
                                value={formData.GRNNumber || ''} onChange={handleChange} name="GRNNumber" />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">LR Date <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="date"
                                value={formatDateForInput(formData.LRDate)} onChange={handleChange} name="LRDate" readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">LR Number <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="text" placeholder="LR Number"
                                value={formData.LRNumber || ''} onChange={handleChange} name="LRNumber" />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 100px' }}>
                            <span className="pg-hcell-label">Total Qty</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.TotalQuantity || ''} readOnly />
                        </div>
                    </div>

                    {/* ── Row 2: Remarks + Totals ── */}
                    <div className="pg-hpanel" style={{ marginTop: 8 }}>
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Remarks</span>
                            <input className="pg-hcell-input" type="text" placeholder="Enter Remarks"
                                value={formData.Remarks || ''} onChange={handleChange} name="Remarks" />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Amount</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.Amount || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">GST Amount</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.GSTAmount || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Total Amount</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.TotalAmount || ''} readOnly />
                        </div>
                    </div>

                    {/* ── Add Item Bar ── */}
                    <div className="pg-item-bar" style={{ marginTop: 12 }}>
                        {errorMessageModel && <div className="pg-alert pg-alert-error" style={{ width: '100%', marginBottom: 0 }}>{errorMessageModel}</div>}
                        <div className="pg-field" style={{ flex: '3 1 200px' }}>
                            <label className="pg-label">Item Name</label>
                            <div style={{ marginTop: 6 }}>
                                <Select
                                    value={selectedItems}
                                    onChange={handleItemSelect}
                                    options={itemsOptions}
                                    placeholder="Select item..."
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        control: (b) => ({ ...b, minHeight: 31, height: 31, fontSize: 12.5, borderColor: 'rgba(200,212,224,0.7)', borderRadius: 6 }),
                                        valueContainer: (b) => ({ ...b, padding: '0 10px' }),
                                        indicatorsContainer: (b) => ({ ...b, height: 31 }),
                                        menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                                    }}
                                />
                            </div>
                        </div>
                        <div className="pg-field narrow">
                            <label className="pg-label">Quantity</label>
                            <input
                                className={`pg-input text-right${!isValid ? ' cash-negative' : ''}`}
                                type="text" placeholder="Qty"
                                value={modalData.Quantity} onChange={handleModalInputChange}
                            />
                        </div>
                        {modalData.balanceStock > 0 && (
                            <div style={{ display: 'flex', alignItems: 'flex-end', fontSize: 11, color: '#64748b', paddingBottom: 4 }}>
                                Stock: {modalData.balanceStock}
                            </div>
                        )}
                        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6 }}>
                            <button className="pg-btn pg-btn-success" onClick={saveModalData}>
                                <AddIcon /> Add
                            </button>
                        </div>
                    </div>

                    {/* ── Items Table ── */}
                    <div className="pg-invoice-table-wrap" style={{ marginTop: 12 }}>
                        <table className="pg-invoice-table">
                            <thead>
                                <tr>
                                    <th>#</th><th>Item Name</th>
                                    <th className="right">Quantity</th><th className="right">Rate</th>
                                    <th className="right">Amount</th><th className="right">GST</th>
                                    <th className="right">Total</th><th className="right">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoicedeatils.length === 0
                                    ? <tr><td colSpan={8} style={{ textAlign: 'center', color: '#94a3b8', padding: 14 }}>No items added yet.</td></tr>
                                    : invoicedeatils.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: 'center', width: 40 }}>{index + 1}</td>
                                            <td style={{ width: '35%' }}>{item.ItemName}</td>
                                            <td className="right">{item.Quantity}</td>
                                            <td className="right">{item.Rate}</td>
                                            <td className="right">{item.Amount}</td>
                                            <td className="right">{item.GSTAmount}</td>
                                            <td className="right" style={{ fontWeight: 700 }}>{item.TotalAmount}</td>
                                            <td className="right">
                                                <IconButton size="small" onClick={() => removeRecord(index)} title="Remove">
                                                    <DeleteIcon style={{ fontSize: 16, color: '#dc2626' }} />
                                                </IconButton>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* ── Confirm Remove Modal ── */}
                {confirmRemove !== null && (
                    <div className="pg-modal-backdrop" onClick={() => setConfirmRemove(null)}>
                        <div className="pg-modal-card" onClick={e => e.stopPropagation()}>
                            <div className="pg-modal-icon-wrap">
                                <WarningAmberIcon className="pg-modal-icon" />
                            </div>
                            <h6 className="pg-modal-title">Remove Item?</h6>
                            <p className="pg-modal-body">This item will be removed from the invoice. This action cannot be undone.</p>
                            <div className="pg-modal-actions">
                                <button className="pg-modal-btn pg-modal-btn-cancel" onClick={() => setConfirmRemove(null)}>Cancel</button>
                                <button className="pg-modal-btn pg-modal-btn-confirm" onClick={confirmRemoveRecord}>
                                    <DeleteIcon style={{ fontSize: 15 }} /> Yes, Remove
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
            </div>
        </Fragment>
    );
};

export default PurchaseReturnCreate;
